import { FiTrash2, FiEdit } from "react-icons/fi";
import styles from "./tabcliente.module.css";
import ui from "../../styles/ui.module.css";

const ListaClientes = ({ clientes, editarCliente, deletarCliente, ordenarClientes, sortBy = 'id', sortDir = 'desc' }) => {
  const lista = Array.isArray(clientes) ? clientes : [];
  const maskCep = (v) => (String(v||'').replace(/\D/g,'').replace(/(\d{5})(\d)/, '$1-$2'));
  const maskTel = (v) => {
    const d = String(v || '').replace(/\D/g, '');
    if (!d) return '';
    if (d.length <= 10) {
      return d
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .slice(0, 14);
    }
    return d
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .slice(0, 15);
  };
  const arrow = (col) => {
    if (sortBy !== col) return '';
    return sortDir === 'asc' ? ' ▲' : ' ▼';
  };

  return (
    <div className={styles["cliente-container"]}>
      {lista.length > 0 ? (
        <>
        <div className="tableScroll">
          <table className={styles["cliente-tabela"]} border="1">
            <thead>
              <tr>
                <th scope="col" className={styles["cliente-th1"]} aria-sort={sortBy === 'id' ? (sortDir === 'asc' ? 'ascending' : 'descending') : 'none'}>
                  <button type="button" className={styles["cliente-sort"]} onClick={() => ordenarClientes("id")} aria-label="Ordenar por ID">
                    ID{arrow('id')}
                  </button>
                </th>
                <th scope="col" className={styles["cliente-th2"]} aria-sort={sortBy === 'nome' ? (sortDir === 'asc' ? 'ascending' : 'descending') : 'none'}>
                  <button type="button" className={styles["cliente-sort"]} onClick={() => ordenarClientes("nome")} aria-label="Ordenar por nome">
                    NOME{arrow('nome')}
                  </button>
                </th>
                <th scope="col" className={styles["cliente-th3"]} aria-sort={sortBy === 'cpf' ? (sortDir === 'asc' ? 'ascending' : 'descending') : 'none'}>
                  <button type="button" className={styles["cliente-sort"]} onClick={() => ordenarClientes("cpf")} aria-label="Ordenar por CPF/CNPJ">
                    CPF/CNPJ{arrow('cpf')}
                  </button>
                </th>
                <th scope="col" className={styles["cliente-th4"]}>CEP</th>
                <th scope="col" className={styles["cliente-th5"]}>Endereço</th>
                <th scope="col" className={styles["cliente-th6"]}>Bairro</th>
                <th scope="col" className={styles["cliente-th7"]}>Cidade/UF</th>
                <th scope="col" className={styles["cliente-th9"]}>Telefone</th>
                <th scope="col" className={styles["cliente-th10"]}>E-mail</th>
                <th scope="col" className={styles["cliente-th8"]}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {lista.map((cliente) => (
                <tr key={cliente.ID}>
                  <td className={styles["cliente-td1"]} >{cliente.ID}</td>
                  <td className={styles["cliente-td2"]} title={cliente.NOME}>{cliente.NOME}</td>
                  <td className={styles["cliente-td3"]} title={cliente.CPF}>{cliente.CPF}</td>
                  <td className={styles["cliente-td4"]} title={cliente.CEP}>{maskCep(cliente.CEP)}</td>
                  <td className={styles["cliente-td5"]} title={cliente.ENDERECO}>{[cliente.ENDERECO, cliente.NUMERO].filter(Boolean).join(', ')}</td>
                  <td className={styles["cliente-td6"]} title={cliente.BAIRRO}>{cliente.BAIRRO}</td>
                  <td className={styles["cliente-td7"]} title={cliente.CIDADE}>{[cliente.CIDADE, cliente.UF].filter(Boolean).join(' / ')}</td>
                  <td className={styles["cliente-td9"]} title={cliente.WHATSAPP_NUMERO}>{maskTel(cliente.WHATSAPP_NUMERO || cliente.TELEFONE)}</td>
                  <td className={styles["cliente-td10"]} title={cliente.EMAIL}>{cliente.EMAIL || ''}</td>
                  <td className={styles["cliente-acoes"]}>
                    <div className={`${ui.buteditarremover}`}>
                      <button title="Editar" className={`${ui.buteditar}`} onClick={() => editarCliente(cliente.ID)} aria-label={`Editar cliente ${cliente.NOME}`}>
                        <FiEdit size={15} />
                      </button>
                      <button title="Excluir" className={`${ui.butremover}`} onClick={() => deletarCliente(cliente.ID)} aria-label={`Remover cliente ${cliente.NOME}`}>
                        <FiTrash2 size={15} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Ultra-mobile cards (<360px): alternativa à tabela */}
        <div className={styles["cliente-cards"]}>
          {lista.map((cliente) => (
            <div className={styles["cliente-card"]} key={`card-${cliente.ID}`}>
              <div className={styles["cl-card-header"]}>
                <span className={styles["cl-card-nome"]} title={cliente.NOME}>{cliente.NOME}</span>
                <span className={styles["cl-card-id"]}>#{cliente.ID}</span>
              </div>
              <div className={styles["cl-card-body"]}>
                <span className={styles["cl-card-cpf"]} aria-label="CPF/CNPJ">{cliente.CPF}</span>
                <span className={styles["cl-card-cep"]}>CEP: {maskCep(cliente.CEP)}</span>
                <span className={styles["cl-card-end"]}>{[cliente.ENDERECO, cliente.NUMERO].filter(Boolean).join(', ')}</span>
                <span className={styles["cl-card-bairro"]}>{cliente.BAIRRO}</span>
                <span className={styles["cl-card-cidade"]}>{[cliente.CIDADE, cliente.UF].filter(Boolean).join(' / ')}</span>
                <span className={styles["cl-card-tel"]}>{maskTel(cliente.WHATSAPP_NUMERO || cliente.TELEFONE)}</span>
                {cliente.EMAIL ? <span className={styles["cl-card-email"]}>{cliente.EMAIL}</span> : null}
              </div>
              <div className={styles["cl-card-actions"]}>
                <button className={styles["cliente-editarbtn"]} onClick={() => editarCliente(cliente.ID)} aria-label={`Editar cliente ${cliente.NOME}`}>
                  <FiEdit size={16} />
                </button>
                <button className={styles["cliente-removerbtn"]} onClick={() => deletarCliente(cliente.ID)} aria-label={`Remover cliente ${cliente.NOME}`}>
                  <FiTrash2 size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>
        </>
      ) : (
        <p>Nenhum cliente encontrado.</p>
      )}
    </div>
  );
};

export default ListaClientes;
